import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { IInvoice } from "./type"

export function useInvoices(
  memberId: string,
  showTrash: boolean,
  config?: UseQueryOptions<IInvoice[]>
) {
  const params = {
    filter: {
      status: {
        operator: "in",
        values: showTrash
          ? ["canceled", "paid", "aborted"]
          : ["sent", "proforma", "recoverable", "unpaid"],
      },
    },
  }
  return useQuery<IInvoice[]>(
    ["operation", "administration", "members", memberId, "invoices", params],
    {
      ...config,
    }
  )
}

export function useInvoice(
  memberId: string,
  invoiceId: string,
  config?: UseQueryOptions<IInvoice>
) {
  return useQuery<IInvoice>(
    ["operation", "administration", "members", memberId, "invoices", invoiceId],
    {
      ...config,
    }
  )
}
